import * as types from "./customerInformationActionTypes";

export function loadCustomerInformation() {
    return { type: types.LOAD_CUSTOMER_INFORMATION };
}

export function loadCustomerInformationSuccess(customerInformation) {
    return { type: types.LOAD_CUSTOMER_INFORMATION_SUCCESS, customerInformation};
}

export function loadCustomerInformationFailed(message) {
    return { type: types.LOAD_CUSTOMER_INFORMATION_FAILED, message };
}


// WEBPACK FOOTER //
// ./src/customer-information/customerInformationActions.js